import { createFileRoute } from '@tanstack/react-router'
import { ResellerDashboardPage } from '@/features/reseller/pages/dashboard'

export const Route = createFileRoute('/_authenticated/reseller/')({
  component: ResellerDashboardPage,
})

